/* --- QUESTIONNAIRE CONFIG --- */

export interface QuestionnaireIBDQ {
  position: number;
  question: string;
  answers: string[];
}

export const Q_IBDQ: QuestionnaireIBDQ[] = [
  {
    // tslint:disable-next-line:max-line-length
    position: 1, question: 'Quanto frequenti sono state le sue evacuazioni nelle ultime 2 settimane? Per favore indichi\n' +
      'quanto frequenti sono state le sue evacuazioni nelle ultime 2 settimane, scegliendo una delle\n' +
      'risposte seguenti:',
    answers: [
      '1 - Frequenza delle evacuazioni simile o superiore al peggior caso del passato',
      '2 - Estremamente frequenti',
      '3 - Molto frequenti',
      '4 - Moderato aumento di frequenza delle evacuazioni',
      '5 - Un qualche aumento di frequenza delle evacuazioni',
      '6 - Un leggero aumento di frequenza delle evacuazioni',
      '7 - Normali, non aumento di frequenza delle evacuazioni'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 2, question: 'Quanto spesso nelle ultime 2 settimane la sensazione di affaticamento o di stanchezza e spossatezza è stata un problema per lei? Per favore indichi quanto frequentemente la sensazione di affaticamento o di stanchezza è stato un problema per lei nelle ultime 2 settimane, scegliendo una delle risposte seguenti:',
    answers: [
      '1 - Tutto il tempo',
      '2 - La maggior parte del tempo',
      '3 - Una buona parte del tempo',
      '4 - Una parte del tempo',
      '5 - Una piccola parte del tempo',
      '6 - Una minima parte del tempo',
      '7 - Mai'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 3, question: 'Quanto spesso nelle ultime 2 settimane si è sentito frustrato, impaziente o agitato? Per favore,scelga una delle risposte seguenti:',
    answers: [
      '1 - Tutto il tempo',
      '2 - La maggior parte del tempo',
      '3 - Una buona parte del tempo',
      '4 - Una parte del tempo',
      '5 - Una piccola parte del tempo',
      '6 - Una minima parte del tempo',
      '7 - Mai'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 4, question: 'Quanto spesso nelle ultime 2 settimane non è riuscito ad andare a scuola o a lavorare a causa della sua malattia intestinale? Per favore, scelga una delle risposte seguenti:',
    answers: [
      '1 - Tutto il tempo',
      '2 - La maggior parte del tempo',
      '3 - Una buona parte del tempo',
      '4 - Una parte del tempo',
      '5 - Una piccola parte del tempo',
      '6 - Una minima parte del tempo',
      '7 - Mai'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 5, question: 'Quanto spesso nelle ultime due settimane le sue evacuazioni sono state liquide? Per favore, scelga una delle risposte seguenti:',
    answers: [
      '1 - Tutto il tempo',
      '2 - La maggior parte del tempo',
      '3 - Una buona parte del tempo',
      '4 - Una parte del tempo',
      '5 - Una piccola parte del tempo',
      '6 - Una minima parte del tempo',
      '7 - Mai'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 6, question: 'Quanta energia ha avuto nelle ultime 2 settimane? Per favore, scelga una delle risposte seguenti:',
    answers: [
      '1 - Nessuna energia',
      '2 - Minima energia',
      '3 - Poca energia',
      '4 - Una qualche energia',
      '5 - Una moderata quantità di energia',
      '6 - Tanta energia',
      '7 - Tantissima energia'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 7, question: 'Quanto spesso nelle ultime 2 settimane si è sentito preoccupato circa la possibilità di doversi sottoporre ad un intervento chirurgico a causa della sua malattia intestinale? Per favore, scelga una delle risposte seguenti:',
    answers: [
      '1 - Tutto il tempo',
      '2 - La maggior parte del tempo',
      '3 - Una buona parte del tempo',
      '4 - Una parte del tempo',
      '5 - Una piccola parte del tempo',
      '6 - Una minima parte del tempo',
      '7 - Mai'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 8, question: 'Quanto spesso nelle ultime 2 settimane ha dovuto rimandare o annullare un impegno sociale a causa della sua malattia intestinale? Per favore, scelga una delle risposte seguenti:',
    answers: [
      '1 - Tutto il tempo',
      '2 - La maggior parte del tempo',
      '3 - Una buona parte del tempo',
      '4 - Una parte del tempo',
      '5 - Una piccola parte del tempo',
      '6 - Una minima parte del tempo',
      '7 - Mai'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 9, question: 'Quanto spesso nelle ultime due settimane è stato disturbato dai crampi addominali? Per favore, scelga una delle seguenti risposte:',
    answers: [
      '1 - Tutto il tempo',
      '2 - La maggior parte del tempo',
      '3 - Una buona parte del tempo',
      '4 - Una parte del tempo',
      '5 - Una piccola parte del tempo',
      '6 - Una minima parte del tempo',
      '7 - Mai'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 10, question: 'Quanto spesso nelle ultime 2 settimane non si è sentito bene? Per favore, scelga una delle seguenti risposte:',
    answers: [
      '1 - Tutto il tempo',
      '2 - La maggior parte del tempo',
      '3 - Una buona parte del tempo',
      '4 - Una parte del tempo',
      '5 - Una piccola parte del tempo',
      '6 - Una minima parte del tempo',
      '7 - Mai'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 11, question: 'Quanto spesso nelle ultime 2 settimane si è sentito preoccupato per la paura di non trovare un bagno? Per favore, scelga una delle risposte seguenti:',
    answers: [
      '1 - Tutto il tempo',
      '2 - La maggior parte del tempo',
      '3 - Una buona parte del tempo',
      '4 - Una parte del tempo',
      '5 - Una piccola parte del tempo',
      '6 - Una minima parte del tempo',
      '7 - Mai'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 12, question: 'Quanta difficoltà ha avuto nelle ultime 2 settimane a svolgere l’attività sportiva o di svago che avrebbe voluto fare, a causa della sua malattia intestinale? Per favore, scelga una delle risposte seguenti:',
    answers: [
      '1 - Grandissima difficoltà; attività impossibile',
      '2 - Molta difficoltà',
      '3 - Una discreta difficoltà',
      '4 - Qualche difficoltà',
      '5 - Piccola difficoltà',
      '6 - Quasi nessuna difficoltà',
      '7 - Nessuna difficoltà; la mia malattia intestinale non ha limitato le attività sportive o di svago',
      ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 13, question: 'Quanto spesso nelle ultime 2 settimane è stato disturbato dai dolori addominali? Per favore, scelga una delle risposte seguenti:',
    answers: [
      '1 - Tutto il tempo',
      '2 - La maggior parte del tempo',
      '3 - Una buona parte del tempo',
      '4 - Una parte del tempo',
      '5 - Una piccola parte del tempo',
      '6 - Una minima parte del tempo',
      '7 - Mai'
      ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 14, question: 'Quanto spesso nelle ultime 2 settimane non ha dormito bene o si è svegliato di notte? Per favore, scelga una delle risposte seguenti:',
    answers: [
      '1 - Tutto il tempo',
      '2 - La maggior parte del tempo',
      '3 - Una buona parte del tempo',
      '4 - Una parte del tempo',
      '5 - Una piccola parte del tempo',
      '6 - Una minima parte del tempo',
      '7 - Mai'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 15, question: 'Quanto spesso nelle ultime 2 settimane si è sentito depresso o scoraggiato? Per favore, scelga una delle risposte seguenti:',
    answers: [
      '1 - Tutto il tempo',
      '2 - La maggior parte del tempo',
      '3 - Una buona parte del tempo',
      '4 - Una parte del tempo',
      '5 - Una piccola parte del tempo',
      '6 - Una minima parte del tempo',
      '7 - Mai'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 16, question: 'Quanto spesso nelle ultime 2 settimane ha dovuto rinunciare a partecipare ad eventi per mancanza di un bagno vicino? Per favore, scelga una delle risposte seguenti:',
    answers: [
    '1 - Tutto il tempo',
    '2 - La maggior parte del tempo',
    '3 - Una buona parte del tempo',
    '4 - Una parte del tempo',
    '5 - Una piccola parte del tempo',
    '6 - Una minima parte del tempo',
    '7 - Mai'
    ]
    },
  {
    // tslint:disable-next-line:max-line-length
    position: 17, question: 'Globalmente nelle ultime 2 settimane, quanto è stato un problema il passaggio di grandi quantità di gas intestinale? Per favore, scelga una delle risposte seguenti:',
    answers: [
      '1 - Un problema grave',
      '2 - Un grosso problema',
      '3 - Un problema significativo',
      '4 - Un disturbo',
      '5 - Un piccolo disturbo',
      '6 - Quasi nessun disturbo',
      '7 - Nessun disturbo'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 18, question: 'Globalmente nelle ultime 2 settimane, quanto è stato un problema mantenere o raggiungere il suo peso ideale? Per favore, scelga una delle risposte seguenti:',
    answers: [
      '1 - Un problema grave',
      '2 - Un grosso problema',
      '3 - Un problema significativo',
      '4 - Un disturbo',
      '5 - Un piccolo disturbo',
      '6 - Quasi nessun disturbo',
      '7 - Nessun disturbo'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 19, question: 'Molti pazienti con problemi intestinali spesso hanno preoccupazioni ed ansie legate alla loro malattia. Queste includono la paura di sviluppare un cancro, la paura di non poter mai più sentirsi meglio, e la paura di avere una ricaduta. Globalmente nelle ultime 2 settimane, quanto spesso si è sentito preoccupato o ansioso? Per favore, scelga una delle risposte seguenti:',
    answers: [
      '1 - Tutto il tempo',
      '2 - La maggior parte del tempo',
      '3 - Una buona parte del tempo',
      '4 - Una parte del tempo',
      '5 - Una piccola parte del tempo',
      '6 - Una minima parte del tempo',
      '7 - Mai'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 20, question: 'Quanto spesso nelle ultime 2 settimane è stato disturbato dalla sensazione di pancia gonfia? Per favore, scelga una delle risposte seguenti:',
    answers: [
      '1 - Tutto il tempo',
      '2 - La maggior parte del tempo',
      '3 - Una buona parte del tempo',
      '4 - Una parte del tempo',
      '5 - Una piccola parte del tempo',
      '6 - Una minima parte del tempo',
      '7 - Mai'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 21, question: 'Quanto spesso nelle ultime 2 settimane si è sentito rilassato e privo di tensioni? Per favore, scelga una delle risposte seguenti:',
    answers: [
      '1 - Mai',
      '2 - Una minima parte del tempo',
      '3 - Una piccola parte del tempo',
      '4 - Una parte del tempo',
      '5 - Una buona parte del tempo',
      '6 - La maggior parte del tempo',
      '7 - Tutto il tempo'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 22, question: 'Quanto spesso nelle ultime 2 settimane ha avuto problemi per la presenza di sanguinamento con le evacuazioni? Per favore, scelga una delle risposte seguenti:',
    answers: [
      '1 - Tutto il tempo',
      '2 - La maggior parte del tempo',
      '3 - Una buona parte del tempo',
      '4 - Una parte del tempo',
      '5 - Una piccola parte del tempo',
      '6 - Una minima parte del tempo',
      '7 - Mai'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 23, question: 'Quanto spesso nelle ultime 2 settimane si è sentito imbarazzato a seguito della sua malattia intestinale? Per favore, scelga una delle risposte seguenti:',
    answers: [
      '1 - Tutto il tempo',
      '2 - La maggior parte del tempo',
      '3 - Una buona parte del tempo',
      '4 - Una parte del tempo',
      '5 - Una piccola parte del tempo',
      '6 - Una minima parte del tempo',
      '7 - Mai'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 24, question: 'Quanto spesso nelle ultime 2 settimane è stato disturbato dalla sensazione di dover andare in bagno anche se aveva l\'intestino vuoto? Per favore, scelga una delle risposte seguenti:',
    answers: [
      '1 - Tutto il tempo',
      '2 - La maggior parte del tempo',
      '3 - Una buona parte del tempo',
      '4 - Una parte del tempo',
      '5 - Una piccola parte del tempo',
      '6 - Una minima parte del tempo',
      '7 - Mai'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 25, question: 'Quanto spesso nelle ultime 2 settimane le sono venute le lacrime agli occhi o si è sentito triste? Per favore, scelga una delle risposte seguenti:',
    answers: [
      '1 - Tutto il tempo',
      '2 - La maggior parte del tempo',
      '3 - Una buona parte del tempo',
      '4 - Una parte del tempo',
      '5 - Una piccola parte del tempo',
      '6 - Una minima parte del tempo',
      '7 - Mai'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 26, question: 'Quanto spesso nelle ultime 2 settimane si è sentito disturbato dall\'avere sporcato inavvertitamente la sua biancheria intima? Per favore, scelga una delle risposte seguenti:',
    answers: [
      '1 - Tutto il tempo',
      '2 - La maggior parte del tempo',
      '3 - Una buona parte del tempo',
      '4 - Una parte del tempo',
      '5 - Una piccola parte del tempo',
      '6 - Una minima parte del tempo',
      '7 - Mai'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 27, question: 'Quanto spesso nelle ultime 2 settimane si è sentito arrabbiato a causa della sua malattia intestinale? Per favore, scelga una delle risposte seguenti:',
    answers: [
      '1 - Tutto il tempo',
      '2 - La maggior parte del tempo',
      '3 - Una buona parte del tempo',
      '4 - Una parte del tempo',
      '5 - Una piccola parte del tempo',
      '6 - Una minima parte del tempo',
      '7 - Mai'
    ]
  },

  {
    // tslint:disable-next-line:max-line-length
    position: 28, question: 'In quale misura nelle ultime 2 settimane la sua malattia intestinale ha limitato la sua attività sessuale? Per favore, scelga una delle risposte seguenti:',
    answers: [
      '1 - Nessuna attività sessuale a causa della mia malattia intestinale',
      '2 - Grande limitazione a causa della mia malattia intestinale',
      '3 - Moderata limitazione a causa della mia malattia intestinale',
      '4 - Limitazione a causa della mia malattia intestinale',
      '5 - Piccola limitazione a causa della mia malattia intestinale',
      '6 - Quasi nessuna limitazione a causa della mia malattia intestinale',
      '7 - Nessuna limitazione a causa della mia malattia intestinale'
    ]
  },

  {
    // tslint:disable-next-line:max-line-length
    position: 29, question: 'Quanto spesso nelle ultime 2 settimane è stato disturbato dalla nausea o dalla voglia di vomitare? Per favore, scelga una delle risposte seguenti:',
    answers: [
      '1 - Tutto il tempo',
      '2 - La maggior parte del tempo',
      '3 - Una buona parte del tempo',
      '4 - Una parte del tempo',
      '5 - Una piccola parte del tempo',
      '6 - Una minima parte del tempo',
      '7 - Mai'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 30, question: 'Quanto spesso nelle ultime 2 settimane si è sentito irritabile? Per favore, scelga una delle risposte seguenti:',
    answers: [
      '1 - Tutto il tempo',
      '2 - La maggior parte del tempo',
      '3 - Una buona parte del tempo',
      '4 - Una parte del tempo',
      '5 - Una piccola parte del tempo',
      '6 - Una minima parte del tempo',
      '7 - Mai'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 31, question: 'Quanto spesso nelle ultime 2 settimane si è sentito incompreso? Per favore, scelga una delle risposte seguenti:',
    answers: [
      '1 - Tutto il tempo',
      '2 - La maggior parte del tempo',
      '3 - Una buona parte del tempo',
      '4 - Una parte del tempo',
      '5 - Una piccola parte del tempo',
      '6 - Una minima parte del tempo',
      '7 - Mai'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 32, question: 'Quanto nelle ultime 2 settimane si è sentito soddisfatto, felice o contento della sua vita personale? Per favore, scelga una delle risposte seguenti:',
    answers: [
      '1 - Molto insoddisfatto, infelice per la maggior parte del tempo',
      '2 - Generalmente insoddisfatto, infelice',
      '3 - Abbastanza insoddisfatto, infelice',
      '4 - Generalmente soddisfatto, contento',
      '5 - Soddisfatto per la maggior parte del tempo, felice',
      '6 - Molto soddisfatto per la maggior parte del tempo, felice',
      '7 - Estremamente soddisfatto, non potrei essere stato più felice e contento'
    ]
  },
  ];

/* ------------ RESULTS CONFIGURATION + CONSTRUCTOR ------------ */

export class IBDQResults {
  patientSSN: string;
  doctorID: string;
  results: string[];
  finalScore: number;

  constructor(doctorID: string, patientSSN: string, results: string[], finalScore: number) {
    this.doctorID = doctorID;
    this.patientSSN = patientSSN;
    this.results = results;
    this.finalScore = finalScore;
  }

}
